import { Icon } from '@iconify/react'
import type { ManagerialKpiCriterion } from '../../lib/managerial-kpi-criteria'
import styles from './KpiCard.module.css'

interface KpiInfoHintProps {
  kpiId: string
  criterion: ManagerialKpiCriterion
  placeAbove: boolean
}

export function KpiInfoHint({ kpiId, criterion, placeAbove }: KpiInfoHintProps) {
  const tooltipId = `${kpiId}-criterion`

  return (
    <span className={placeAbove ? `${styles.hint} ${styles.hintAbove}` : styles.hint}>
      <button
        type="button"
        className={styles.hintButton}
        aria-label={`Detalhe de ${criterion.title}`}
        aria-describedby={tooltipId}
      >
        <Icon icon="mdi:information-outline" aria-hidden />
      </button>
      <span id={tooltipId} role="tooltip" className={styles.hintCard}>
        <span className={styles.hintDescription}>{criterion.description}</span>
        {criterion.illustrativeNote ? (
          <span className={styles.hintNote}>{criterion.illustrativeNote}</span>
        ) : null}
      </span>
    </span>
  )
}
